import { AuditEntity } from "@app/common";
import { Column, Display, FormField, prop, required, Table } from "@messaia/cdk";

@Table({
    endpoint: 'contentvariable',
    includes: ['Client']
})
export class ContentVariable extends AuditEntity {
    @prop()
    title: string;

    @required()
    @FormField({ row: 2 })
    @Column({})
    @Display($localize`:@@name:Name`)
    name: string;

    @required()
    @FormField({ row: 3 })
    @Column({ showGtSm: true })
    @Display($localize`:@@value:Value`)
    value: string;

    @required()
    @FormField({ row: 1, endpoint: 'client?enabled=true&projection=id,name' })
    @Column({ name: 'client.displayName', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 250, showGtXl: true })
    @Display($localize`:@@client:Client`)
    clientId: number;

    @prop()
    @FormField({ row: 4 })
    @Column({})
    @Display($localize`:@@default:Default`)
    default: boolean;

    @prop()
    @FormField({ row: 5 })
    @Column({ event: 'toggle' })
    @Display($localize`:@@enabled:Enabled`)
    enabled: boolean;
}